require('./bootstrap');
require('./jquery-ui');
require('jquery-ui-sortable-npm');
//import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
//window.ScrollReveal = require('scrollreveal/dist/scrollreveal.js');
window.AOS = require('aos/dist/aos.js');

import { Fancybox } from "@fancyapps/ui";
window.Fancybox = Fancybox;